import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    setAction, resetAction
} from 'one-state-medicalhistory/src/actions';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';
import { Disposition } from 'one-model-local';
export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
}
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
/**
 * This Fuction will fetch the data of Medical History
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchMedicalHistoryEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server, log, agentId,teamName, settings: {
            epicendpoints: {
                medicalhistory, apitoken
            },
            uisettings: {
                dashboardapiconfig: {
                    medicalhistory : medicalhistoryApi
                }
            },
            compatible : { consolidated_api_invocation, contact_center_type },
        } } = context;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient Medical history response
                 */
                let dataresponse: any = action.payload;

                const callMedicalhistoryAPI = (datares: any) => {
                    if (datares?.id) {
                        let headers = new Headers();
                        // todo need to refractor to include authorization in interface
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const responsefromAPI = server.get({
                            headers: headers,
                            path: medicalhistory + "?PatientID=" + (datares?.id)
                        })
                            .then((responsehistory: any) => responsehistory)
                            .catch((medicalhistoryres: any) => {
                                log.error(
                                    "ccw-gadget,medicalhistory-epic",
                                    "medical history-epic", {
                                    medicalhistoryres
                                }
                                );
                                let errorbuild: ErrorObject={
                                    source:"MedicalHistory",
                                    type:"error",
                                    status:medicalhistoryres?.status,
                                    erroritems:medicalhistoryres?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        log.debug(
                            "ccw-gadget,medicalhistory-epic",
                            "medicalhistory-epic response", {
                            responsefromAPI
                        });
                        return from(responsefromAPI)
                    } else {
                        return from([]);
                    }

                }
                //Calling callMedicalhistoryAPI function here
                //the reason is we need to use pipe function.
                if (!medicalhistoryApi) return []
                return callMedicalhistoryAPI(dataresponse).
                    pipe(
                        map((responsereceived: any) => TransformResponse(responsereceived, context))).
                    pipe(
                        flatMap(responseAfterTransform => {
                            const actions:any =[
                                setAction(responseAfterTransform.medicalhistory)
                            ];
                            if(responseAfterTransform.error){
                                actions.push(addAction(responseAfterTransform.error));
                                let disp: Disposition = { value: "1006" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.id;
                                disp.meta03 = responseAfterTransform?.error?.status;
                                disp.meta04 = responseAfterTransform?.error?.erroritems[0]?.error_detail;
                                disp.meta05 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "189" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.id;
                                disp.meta03 = '200';
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);
/**
 * Listen for component clear and intiate state clear for Active Problems
 * @param context  contains logger which is used for logging
 */
export const clearMedicalHistoryEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, medicalhistory-epic",
            "clear-medical history-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )

    }
);